import { baseColors } from '@/theme/tokens/base/colors'
import { opacity } from '@/theme/tokens/base/opacity'
import { createBrandTokens } from '@/theme/tokens/alias/brandTokens'
import { createSemanticColors } from '@/theme/semantic/semanticColors'
import { createSemanticInteraction } from '@/theme/semantic/semanticInteraction'
import { createSemanticSurface } from '@/theme/semantic/semanticSurface'
import type { ThemeTokens } from '@/theme/types'
import { borders } from '@/theme/tokens/base/borders'
import { elevation } from '@/theme/tokens/base/elevation'
import { motion } from '@/theme/tokens/base/motion'
import { radius } from '@/theme/tokens/base/radius'
import { spacing } from '@/theme/tokens/base/spacing'
import { typography } from '@/theme/tokens/base/typography'
import { zIndex } from '@/theme/tokens/base/zIndex'
import { createButtonTokens } from '@/theme/tokens/component/button.tokens'
import { createInputTokens } from '@/theme/tokens/component/input.tokens'
import { createCardTokens } from '@/theme/tokens/component/card.tokens'

export const darkThemeTokens: ThemeTokens = {
  base: {
    colors: baseColors,
    spacing,
    radius,
    typography,
    elevation,
    opacity,
    motion,
    zIndex,
    borders,
  },
  alias: createBrandTokens('dark'),
  semantic: {} as ThemeTokens['semantic'],
  components: {} as ThemeTokens['components'],
}

const baseSemanticColors = createSemanticColors(darkThemeTokens.alias, 'dark')
const baseSemanticSurface = createSemanticSurface(darkThemeTokens.alias)

darkThemeTokens.semantic = {
  colors: {
    ...baseSemanticColors,
    background: '#121212',
    surface: '#1A1A1A',
    surfaceElevated: '#1E1E1E',
  },
  interaction: createSemanticInteraction(darkThemeTokens.alias, darkThemeTokens.base.opacity, 'dark'),
  surface: {
    ...baseSemanticSurface,
    surface: '#1A1A1A',
    surfaceElevated: '#1E1E1E',
    surfaceOverlay: 'rgba(0, 0, 0, 0.5)',
  },
}

darkThemeTokens.components = {
  button: createButtonTokens(
    darkThemeTokens.semantic,
    darkThemeTokens.base.radius,
    darkThemeTokens.base.spacing,
  ),
  input: createInputTokens(
    darkThemeTokens.semantic,
    darkThemeTokens.base.radius,
    darkThemeTokens.base.spacing,
  ),
  card: createCardTokens(
    darkThemeTokens.base.radius,
    darkThemeTokens.base.spacing,
    2,
  ),
}

export const darkElevationMap = {
  surface: `${elevation[1]}, 0 0 0 1px rgba(255, 255, 255, 0.04)`,
  dropdown: `${elevation[3]}, 0 0 0 1px rgba(255, 255, 255, 0.06)`,
  modal: `${elevation[4]}, 0 0 0 1px rgba(255, 255, 255, 0.08)`,
  overlay: `${elevation[5]}, 0 0 0 1px rgba(255, 255, 255, 0.1)`,
}


